// test1885
(1885 && 0);
